import React from 'react';
import Select from 'react-select';

import './RecurrenceSettingsInput.scss';

const defaultIntervalOptions = [
  { value: 'day', label: 'day(s)' },
  { value: 'week', label: 'week(s)' },
];

const selectStyles = {
  control: base => ({ ...base, height: '100%', minHeight: '30px', alignItems: 'baseline' }),
  valueContainer: base => ({ ...base, height: '100%' }),
  indicatorsContainer: base => ({ ...base, height: '100%' }),
  input: base => ({ ...base, height: '20px', display: 'flex', alignItems: 'center' }),
  menuPortal: base => ({ ...base, zIndex: 9999 }),
};

type Props = {
  label?: string;
  amountValue?: number | string;
  className?: string;
  onAmountValueChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  intervalValue: string;
  intervalOptions?: Array<{
    value: string;
    label: string;
  }>;
  onIntervalValueChange: Function;
};

function RecurrenceSettingsInput({
  label,
  className = '',
  amountValue,
  onAmountValueChange,
  intervalValue,
  intervalOptions = defaultIntervalOptions,
  onIntervalValueChange,
}: Props) {
  return (
    <div className={`d-flex align-items-center mb-2 ${className}`}>
      {label && <span className="mr-2">{label}</span>}
      {onAmountValueChange && (
        <input
          className="recurrence-section-amount pl-1 py-1 mr-2"
          type="number"
          name="recurrenceAmount"
          min="1"
          step="1"
          value={amountValue}
          onChange={onAmountValueChange}
        />
      )}
      <Select
        className="recurrence-section-interval"
        options={intervalOptions}
        value={intervalOptions.find(({ value }) => value === intervalValue)}
        styles={selectStyles}
        menuPortalTarget={document.body}
        onChange={onIntervalValueChange}
        components={{
          IndicatorSeparator: null,
        }}
      />
    </div>
  );
}

export default RecurrenceSettingsInput;
